<template>
  <div>
    <a
      class="btn btn-sm btn-success"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
    >
      <i class="os-icon os-icon-ui-22"></i>
      <span>Nueva Conversión</span>
    </a>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header smaller">
            <h5 class="modal-title">Nueva Conversión</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <TiendaSelectComponent
                  @change="selectPosicion(current)"
                  :current="current"
                />
              </div>
              <div v-if="posicion" class="col-12">
                <label>Posición</label>
                <select class="form-control" v-model="current.posicion">
                  <option
                    v-for="(data, key) in posicion"
                    :value="data.id"
                    :key="key"
                  >
                    Id: {{ data.id }} - Barra: {{ data.barra }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <ProductoSelectComponent :current="current" />
              </div>
              <div v-if="current.producto" class="col-6">
                <label>Producto Lote</label>
                <select class="form-control" v-model="current.producto_lote">
                  <option
                    v-for="(lote, key) in current.producto.productolote_set"
                    :value="lote.id"
                    :key="key"
                  >
                    id: {{ lote.id }} - lote: {{ lote.codigo_lote }}
                  </option>
                </select>
              </div>
              <div v-if="current.producto" class="col-6">
                <label>Cantidad</label>
                <input
                  v-model="current.cantidad"
                  class="form-control"
                  type="text"
                  v-on:keyup.enter="guardar(current)"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="guardar(current)"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";

export default {
  components: {
    ProductoSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      posicion: "",
      current: {
        producto: "",
        tienda: "",
        estado: "A",
        errors: {},
      },
    };
  },
  mounted() {},
  methods: {
    dateCurrent() {
      this.date = new Date();
      //Año
      this.y = this.date.getFullYear();
      //Mes
      this.m = this.date.getMonth() + 1;
      //Día
      this.d = this.date.getDate();
      this.date_current = this.d + "/" + this.m + "/" + this.y;
    },
    guardar(current) {
      let self = this;
      self.dateCurrent();
      current.fecha = this.date_current;
      if (current.producto) {
        current.producto = current.producto.sku;
      }
      DynamicService.save("inv", "conversion-e", current)
        .then((response) => {
          Notifications.alert.success(
            "Conversión",
            "Se ha guardado la información"
          );
          self.$router.push({
            name: "inventario-conversiones-editar",
            params: { id: response.data.id },
          });
          $("#modalAddProductoPrecio").modal("hide");
        })
        .catch((error) => {
          Notifications.alert.error(
            "Crear Nueva Conversión",
            error.response.data.detail
          );
        });
    },
    selectPosicion(current) {
      let self = this;
      DynamicService.fetch("cat", "tienda-posicion", {
        tienda: current.tienda,
      }).then((response) => {
        self.posicion = response.data.results;
      });
    },
  },
};
</script>
